var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.color,"depressed":"","disabled":_vm.disabled,"x-small":_vm.small},on:{"click":_vm.click}},[_vm._t("default"),_c('a',{ref:"link",staticClass:"d-none",attrs:{"href":_vm.url}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }